import { Close } from '@mui/icons-material'
import {
  Box,
  Dialog,
  DialogContent,
  DialogProps,
  IconButton,
} from '@mui/material'
import {
  forwardRef,
  PropsWithChildren,
  useCallback,
  useImperativeHandle,
  useRef,
} from 'react'
import { useTranslation } from 'react-i18next'

const Modal = forwardRef<ModalRef, ModalProps>((props, ref) => {
  const {
    closesWithConfirm = false,
    onClose,
    children,
    ...passingProps
  } = props

  const { t } = useTranslation()

  const contentRef = useRef<HTMLElement>(null)

  useImperativeHandle(ref, () => ({
    toTop: () => {
      contentRef.current?.scrollTo(0, 0)
    },
  }))

  const handleClose = useCallback(() => {
    if (closesWithConfirm) {
      if (window.confirm(t('Sure to leave? Your work will not be saved.'))) {
        onClose?.()
      }

      return
    }

    onClose?.()
  }, [closesWithConfirm, onClose, t])

  return (
    <Dialog
      container={document.getElementById('root')?.firstElementChild}
      onClose={handleClose}
      {...passingProps}
    >
      <Box textAlign="end" px={2.5} py={1.25}>
        <IconButton onClick={handleClose}>
          <Close fontSize="small" />
        </IconButton>
      </Box>
      <DialogContent ref={contentRef}>{children}</DialogContent>
    </Dialog>
  )
})

type ModalProps = PropsWithChildren &
  Pick<DialogProps, 'open'> & {
    closesWithConfirm?: boolean
    onClose?: VoidFunction
  }

type ModalRef = {
  toTop: VoidFunction
}

export { Modal }
export type { ModalProps, ModalRef }
